import ThumbnailCard from "@components/Blocks/Card/Thumbnail/ThumbnailCard";
import CustomCarousel from "@components/Blocks/CustomCarousel/CustomCarousel";
import SubSectionNav from "@components/Blocks/SubSectionNav/SubSectionNav";
import InlineVideoPlayer from "@elements/Player/InlineVideoPlayer";
import { SectionTitleV2 } from "@elements/Typography/TitleV2";
import WidgetWrapper from "@routes/Home/HomePageLayout/WidgetWrapper";
import { NoSSR } from "@sphtech/web2-core/components";
import type { LatestVideoResponse } from "@typings/Brightcove.d";

type RingkasVideoPageProps = {
  playing: LatestVideoResponse | undefined;
  videos: LatestVideoResponse[] | undefined;
  sectionName: string;
  handleOnClickThumbnail: (props: LatestVideoResponse) => void;
  handleOnEndedVideo?: () => void;
  onSlideChange?: (index: number) => void;
  isMute: boolean;
  setIsMute: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function RingkasVideoPage(props: RingkasVideoPageProps) {
  const {
    videos,
    sectionName,
    handleOnClickThumbnail,
    handleOnEndedVideo,
    onSlideChange,
    playing,
    isMute,
    setIsMute,
  } = props;

  const displaySectionName = "Multimedia";
  const sectionHeading = `Ringkas - ${displaySectionName}`;

  return (
    <>
      <WidgetWrapper className="hidden lg:block lg:px-0">
        <SectionTitleV2
          sectionName={displaySectionName}
          sectionHeading={sectionHeading}
        />
        <NoSSR>
          <SubSectionNav
            sectionName={sectionName}
            displaySection={displaySectionName}
          />
        </NoSSR>

        <CustomCarousel
          className="mt-5 mb-6"
          onSlideChange={onSlideChange}
          containerClassName="items-start"
          navigationClassName="pt-[24%]"
        >
          {videos?.map((video) => (
            <ThumbnailCard
              key={video.id}
              handleOnClickThumbnail={handleOnClickThumbnail}
              variant="ringkas_video_page"
              renderThumbnail={(item, defaultThumbnail) => {
                if (playing?.id !== item.id) {
                  return defaultThumbnail;
                }

                return (
                  <InlineVideoPlayer
                    playing={item}
                    isMute={isMute}
                    setIsMute={setIsMute}
                    onEnded={handleOnEndedVideo}
                    nextPlaylist={handleOnEndedVideo}
                    syncMuteAcrossPlayers={false}
                    pageRefValue="ringkas_video_page"
                  />
                );
              }}
              {...video}
            />
          ))}
        </CustomCarousel>
      </WidgetWrapper>
    </>
  );
}
